const Formats = {
  date: {
    day: 'dddd',
    hourMin: 'HH:mm',
    dayMonthYear: 'DD.MM.YYYY',
    dayMonthYearHourMin: 'DD.MM.YYYY HH:mm',
    datetimeFileFormat: 'YYYY-MM-DD-HH-mm-ss',
  },
  weekdays: {
    en: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    nl: [
      'Zondag',
      'Maandag',
      'Dinsdag',
      'Woensdag',
      'Donderdag',
      'Vrijdag',
      'Zaterdag',
    ],
    de: [
      'Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag',
    ],
    fr: [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ],
  },
};

export default Formats;
